import { createContext } from 'react';
import type { AdminNavCounts } from '@bravemove/types';

export interface NavCountsValue {
  /** The latest badge counts; a key is absent until loaded or when not permitted. */
  readonly counts: AdminNavCounts;
  /** Re-read the counts now, skipping the API cache. */
  readonly refresh: () => void;
}

/**
 * F60b — sidebar badge counts, provided once by `NavCountsProvider` in the admin
 * shell. The default (no provider, e.g. a component test) is "no counts".
 */
export const NavCountsContext = createContext<NavCountsValue>({
  counts: {},
  refresh: () => undefined,
});
